<mat-toolbar color="accent">
  <h2>Select Report Template</h2>
</mat-toolbar>
<mat-dialog-content class="bg-slate-50 !text-black">
  <div class="flex flex-col gap-4 px-4">
    <mat-form-field class="bg-white" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput placeholder="Search" [formControl]="searchCtrl" />
      @if (searchCtrl.value) {
        <button mat-icon-button matSuffix (click)="searchCtrl.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      @for (template of filteredTemplates(); track $index) {
        <pr-select-report-template-card
          [template]="template"
          (selected)="select(template)"
        />
      } @empty {
        <div class="col-span-full flex flex-col items-center justify-center">
          <pr-empty-state image="list" title="Report Templates" />
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
  </pt-buttons-container>
</mat-dialog-actions>
